module.exports = __webpack_public_path__ + "img/preventivo.3da5e5b3.png";